import { createPermissionCheck } from 'common/utils/helpers';
import {
  COMMISSION_PERMISSION_NAME,
  SEARCH_COMMISSION_PERMISSION_NAME,
  SW_DEFAULT_SWVERSION_READ,
  SW_PROTECTED_DEVICE_READ,
  SW_FACTORY_DEVICE_READ,
  CM_EVENTLOG_PERMISSION,
  CM_GET_RASTER_HEATMAP,
  CM_CREATE_RASTER_HEATMAP,
  CM_REBOOT,
  CM_SET_GAIN,
  CM_SET_SERVICE_STATE
} from './constants';

export const hasCommissionPermission = createPermissionCheck([
  COMMISSION_PERMISSION_NAME,
  SEARCH_COMMISSION_PERMISSION_NAME,
  SW_DEFAULT_SWVERSION_READ,
  SW_PROTECTED_DEVICE_READ,
  SW_FACTORY_DEVICE_READ
]);

export const hasCmEventLogsPermission = createPermissionCheck([CM_EVENTLOG_PERMISSION]);

export const hasCmGetRasterHeatmapPermission = createPermissionCheck([CM_GET_RASTER_HEATMAP]);

export const hasCmCreateRasterHeatmapPermission = createPermissionCheck([CM_CREATE_RASTER_HEATMAP]);

export const hasCmRebootPermission = createPermissionCheck([CM_REBOOT]);

export const hasCmGainSettingsPermission = createPermissionCheck([CM_SET_GAIN]);

export const hasGa2ProvisionPermission = createPermissionCheck([
  COMMISSION_PERMISSION_NAME,
  SEARCH_COMMISSION_PERMISSION_NAME
]);

export const hasSetServiceStatePermission = createPermissionCheck([CM_SET_SERVICE_STATE]);

export const rebootSuccessMessage =
  'Rebooting in Progress, allow for up to five (5) minutes to complete. It is recommended NOT to perform any changes to the system until after Reboot is completed.';
